<template>
  <div>
    <b-container class="mt-5 pt-5">
      <h4 class="mt-5 d-block text-center">صفحه مورد نظر یافت نشد</h4>

      <router-link
          :to="{ name: 'Home' }"
          class="d-block router-link-color mx-2"
      >
        <b-button
            block
            pill
            type="submit"
            class="my-3 "
            variant="purple"
        >بازگشت به صفحه اصلی


        </b-button>
      </router-link>

    </b-container>
  </div>
</template>

<script>
export default {
  name: "NotFound",

};
</script>
<style scoped>
h4 {
  color: var(--primary);
}

.router-link-color {
  color: #fff !important;
  text-decoration: none;
}

</style>